import axios from "axios";
import { ApiUrl } from "./ApiUrl";

export const ScheduleData = () => {
  return axios
    .request({
      method: "GET",
      url: `${ApiUrl}/shuttleSettings`,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e.message);
    });
};
